import { type ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';
import BackButton from './common/BackButton';

import styles from './NarrowColumnContainer.module.scss';

import { useAppSelector } from '@/store/new-order';

interface NarrowColumnContainerProps {
  children: ReactNode;
  onBackButtonClick: () => void;
  title?: string;
}

const NarrowColumnContainer = ({ children, onBackButtonClick, title }: NarrowColumnContainerProps) => {
  const isSubmitting = useAppSelector((state) => state.isSubmitting);

  return (
    <main className={styles.container}>
      <BackButton disabled={isSubmitting} onClick={onBackButtonClick} />

      <h1 className={styles.title}>
        {title ?? (
          <FormattedMessage
            id="layout.defaultTitle"
            defaultMessage="Let’s start your subscription!"
            description="Defaut title of payment screens"
          />
        )}
      </h1>

      {children}
    </main>
  );
};

export default NarrowColumnContainer;
